<h2 style="cursor:pointer; display:block;" class="flex-aligned-div" (click)="openLogsHistory()">
  Logs History
  <mat-icon data-html="true" style="color:white">info</mat-icon>
</h2>
@if (showTable) {
  <div class="example-container">
    <table mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      (matSortChange)="sortData($event)"
      class="mat-elevation-z8 mat-table-custom" id="provisioningratemplate">
      @for (item of columnsToDisplay; track item) {
        <ng-container matColumnDef="{{item}}">
          <th mat-header-cell *matHeaderCellDef>
            @switch (item) {
              @case ('CommandId') {
                <span mat-sort-header="CommandId">{{item}}</span>
              }
              @case ('CommandName') {
                <span mat-sort-header="CommandName">{{item}}</span>
              }
              @case ('Category') {
                <span mat-sort-header="Category">{{item}}</span>
              }
              @default {
                <span>{{item === 'actions' ? '' : item}}</span>
              }
            }
          </th>
          @if (item==='actions') {
            <td mat-cell *matCellDef="let element">
              @if (!getInput(element,'IsEnabled') && isEditable(element.Category) && !element.IsDefaultEnabled) {
                <button mat-icon-button (click)="changeElement(element, 'IsEnabled', true)" matTooltip="Allow Remote Action Value">
                  <mat-icon class="mat-icon-grey">toggle_off</mat-icon>
                </button>
              }
              @if (getInput(element,'IsEnabled') && isEditable(element.Category) && !element.IsDefaultEnabled) {
                <button mat-icon-button (click)="changeElement(element, 'IsEnabled', false)" matTooltip="Disallow Remote Action">
                  <mat-icon class="mat-icon-green">toggle_on</mat-icon>
                </button>
              }
              @if (!getInput(element,'IsEnabled') && (!isEditable(element.Category) || element.IsDefaultEnabled)) {
                <p class="mat-icon-grey"
                  matTooltip="Remote Action - Cannot be enabled/disabled">
                  Disabled
                </p>
              }
              @if (getInput(element,'IsEnabled') && (!isEditable(element.Category) || element.IsDefaultEnabled)) {
                <p class="green" matTooltip="Enabled by default as Always Active Remote Action + Gateway Remote Action or Enabled per Controller Type">
                  Enabled
                </p>
              }
            </td>
          }
          @if (item!=='actions') {
            <ng-container *matCellDef="let element">
              @switch (getDataType(item)) {
                @case ('string') {
                  <td mat-cell>
                    @if (item == 'CommandName') {
                      <p>
                        <span [innerHTML]="getCommandLabel(element)"></span>
                        <button mat-icon-button [matTooltip]="element['CommandName']">
                          <mat-icon>info</mat-icon>
                        </button>
                      </p>
                    }
                    @if (item != 'CommandName') {
                      <p [innerHTML]="getInput(element,item)"></p>
                    }
                  </td>
                }
                @case ('date') {
                  <td mat-cell class="datepicker">
                    <p [innerHTML]="getInput(element,item) | date:'yyyy-MM-dd HH:mm'"></p>
                  </td>
                }
              }
            </ng-container>
          }
        </ng-container>
      }
      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;" class="item">
      </table>
    </div>
  }
